import { render, staticRenderFns } from "./tr-weekpicker.vue?vue&type=template&id=f2f30862&scoped=true&"
import script from "./tr-weekpicker.vue?vue&type=script&lang=js&"
export * from "./tr-weekpicker.vue?vue&type=script&lang=js&"
import style0 from "./tr-weekpicker.vue?vue&type=style&index=0&id=f2f30862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f30862",
  null
  
)

export default component.exports